/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { refreshViews } from './refreshViews.tsx';
import { updateContainerState } from './updateContainerState.tsx';

const blockRefresh =
	(): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		const numberOfRefreshBlocks = getState().containers[containerId].numberOfRefreshBlocks + 1;

		setState(
			updateContainerState(getState(), containerId, {
				lastRefreshBlockTime: Date.now(),
				numberOfRefreshBlocks,
			}),
		);
	};

const unblockRefresh =
	(): Action<State, Props> =>
	async ({ setState, getState, dispatch }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		const numberOfRefreshBlocks = getState().containers[containerId].numberOfRefreshBlocks - 1;

		setState(
			updateContainerState(getState(), containerId, {
				lastRefreshBlockTime: Date.now(),
				numberOfRefreshBlocks: numberOfRefreshBlocks < 0 ? 0 : numberOfRefreshBlocks,
			}),
		);

		if (getState().containers[containerId].scheduledRefresh) {
			dispatch(refreshViews());
		}
	};

export const withRefreshBlocker = (fn: Action<State, Props>): Action<State, Props> => {
	return async (api, props) => {
		const { dispatch } = api;
		dispatch(blockRefresh());
		try {
			await fn(api, props);
		} finally {
			dispatch(unblockRefresh());
		}
	};
};
